/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Scholarshiptype202,
  PostApiV1Scholarshiptype400,
  PostApiV1Scholarshiptype401,
  PostApiV1Scholarshiptype404,
  PostApiV1Scholarshiptype500,
  PostApiV1ScholarshiptypeMutationRequest,
  PostApiV1ScholarshiptypeMutationResponse,
} from "../../types/scholarshipTypeRegistroController/PostApiV1Scholarshiptype.ts";
import { scholarshipTypeFileRequestViewModelSchema } from "../scholarshipTypeFileRequestViewModelSchema.ts";
import { scholarshipTypeViewModelSchema } from "../scholarshipTypeViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Scholarshiptype202Schema = z.lazy(
  () => scholarshipTypeViewModelSchema,
) as unknown as ToZod<PostApiV1Scholarshiptype202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Scholarshiptype400Schema =
  z.any() as unknown as ToZod<PostApiV1Scholarshiptype400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Scholarshiptype401Schema =
  z.any() as unknown as ToZod<PostApiV1Scholarshiptype401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1Scholarshiptype404Schema =
  z.any() as unknown as ToZod<PostApiV1Scholarshiptype404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Scholarshiptype500Schema =
  z.any() as unknown as ToZod<PostApiV1Scholarshiptype500>;

export const postApiV1ScholarshiptypeMutationRequestSchema = z.object({
  CompanyId: z.optional(z.number().int()),
  Description: z.optional(z.string()),
  Instruction: z.optional(z.string()),
  HasFixedValue: z.optional(z.boolean()),
  Percentage: z.optional(z.number()),
  ExemptRegistrationValue: z.optional(z.boolean()),
  Files: z.optional(
    z.array(z.lazy(() => scholarshipTypeFileRequestViewModelSchema)),
  ),
}) as unknown as ToZod<PostApiV1ScholarshiptypeMutationRequest>;

export const postApiV1ScholarshiptypeMutationResponseSchema = z.lazy(
  () => postApiV1Scholarshiptype202Schema,
) as unknown as ToZod<PostApiV1ScholarshiptypeMutationResponse>;
